import { Card, CardContent, Typography, Box } from "@mui/material"

export default function ErrorDetailsForm({errorData}){
    return(
        <Box>
            <Card variant="outlined" sx={{ minWidth: 100, mb:2 }}>
                <CardContent>
                <Typography variant="h5" component="div"> Tenant Name: {errorData.related_occupancy.related_tenant.first_name} {errorData.related_occupancy.related_tenant.last_name} </Typography>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom > Tenant Contact: +256{errorData.related_occupancy.related_tenant.phone_number} </Typography>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom > Tenant Number: {errorData.related_occupancy.related_tenant.tenant_number} </Typography>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom > Unit: {errorData.related_occupancy.related_rental_unit.unit_name} </Typography>
                </CardContent>
            </Card>

            <Card variant="outlined" sx={{ minWidth: 100 }}>
                <CardContent>
                <Typography variant="h5" component="div"> Error: {errorData.error}</Typography>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom > <strong>Log Category:</strong> {errorData.log_category} </Typography>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom > <strong>Log Severity:</strong> {errorData.log_severity} </Typography>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom > <strong>Error Stack Trace:</strong> {errorData.error_stack_trace} </Typography>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom ><strong>Error Description:</strong> {errorData.error_description} </Typography>
                </CardContent>
            </Card>
        </Box>
    )
}

